export const tracking = {
    trackFacebookPixelId: () => {},
};
